export enum DownloadType {
  MEDIA,
  BULLETIN_EXTREMADURA,
  PDF,
  BULLETIN_WILDFIRE_EXTREMADURA,
  BULLETIN_PDF
}
